export const appsAppGroupIdChartsTriggerIam = "/apps/:app_group_id/charts/trigger_iam";
